module.exports = __webpack_public_path__ + "img/heart_5.eadaa6bb.png";